(function () {
  const cardSelector = [
    '.moztech-bento-card',
    '.comparison-cell.product-title',
    '.scrolly-step-card'
  ].join(',');

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initTiltCards(root) {
    if (prefersReducedMotion() || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    root.querySelectorAll(cardSelector).forEach((card) => {
      if (card.dataset.mz3dTiltReady === 'true') return;
      card.dataset.mz3dTiltReady = 'true';

      const reset = () => {
        card.style.setProperty('--mz3d-tilt-x', '0deg');
        card.style.setProperty('--mz3d-tilt-y', '0deg');
        card.style.setProperty('--mz3d-pointer-x', '50%');
        card.style.setProperty('--mz3d-pointer-y', '50%');
      };

      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;
        const tiltX = (0.5 - y) * 7;
        const tiltY = (x - 0.5) * 9;

        card.style.setProperty('--mz3d-tilt-x', `${tiltX.toFixed(2)}deg`);
        card.style.setProperty('--mz3d-tilt-y', `${tiltY.toFixed(2)}deg`);
        card.style.setProperty('--mz3d-pointer-x', `${(x * 100).toFixed(1)}%`);
        card.style.setProperty('--mz3d-pointer-y', `${(y * 100).toFixed(1)}%`);
      }, { passive: true });

      card.addEventListener('pointerleave', reset, { passive: true });
    });
  }

  function initHeroCanvas() {
    if (prefersReducedMotion()) return;

    const canvas = document.getElementById('hero-particle-canvas');
    if (!canvas || canvas.dataset.mz3dCanvasReady === 'true') return;
    canvas.dataset.mz3dCanvasReady = 'true';

    const context = canvas.getContext('2d', { alpha: true });
    if (!context) return;

    const mobile = window.matchMedia('(max-width: 768px)').matches;
    let width = 0;
    let height = 0;
    let frameId = 0;
    let isVisible = false;
    let pageScrolling = false;
    let scrollResumeTimer = 0;
    let lastRenderedAt = 0;
    const particles = Array.from({ length: mobile ? 18 : 48 }, (_, index) => ({
      x: (index * 97) % 100,
      y: (index * 53) % 100,
      z: 0.28 + ((index * 17) % 100) / 140,
      drift: 0.24 + ((index * 11) % 100) / 210
    }));

    const resize = () => {
      const ratio = mobile ? 1 : Math.min(window.devicePixelRatio || 1, 1.5);
      const rect = canvas.getBoundingClientRect();
      width = Math.max(1, Math.round(rect.width));
      height = Math.max(1, Math.round(rect.height));
      canvas.width = Math.round(width * ratio);
      canvas.height = Math.round(height * ratio);
      context.setTransform(ratio, 0, 0, ratio, 0, 0);
    };

    const render = (time) => {
      if (!isVisible || pageScrolling) {
        frameId = 0;
        return;
      }

      if (mobile && time - lastRenderedAt < 33) {
        frameId = requestAnimationFrame(render);
        return;
      }
      lastRenderedAt = time;

      context.clearRect(0, 0, width, height);
      context.lineWidth = 1;

      particles.forEach((particle, index) => {
        const x = ((particle.x + time * 0.002 * particle.drift) % 100) / 100 * width;
        const y = ((particle.y + Math.sin(time * 0.00045 + index) * 6) / 100) * height;
        const radius = 1.1 + particle.z * 1.7;
        const alpha = 0.12 + particle.z * 0.26;

        context.beginPath();
        context.arc(x, y, radius, 0, Math.PI * 2);
        context.fillStyle = `rgba(43, 185, 237, ${alpha})`;
        context.fill();

        if (!mobile && index % 3 === 0) {
          const next = particles[(index + 7) % particles.length];
          const nx = ((next.x + time * 0.002 * next.drift) % 100) / 100 * width;
          const ny = ((next.y + Math.sin(time * 0.00045 + index + 7) * 6) / 100) * height;
          const distance = Math.hypot(nx - x, ny - y);
          if (distance < 220) {
            context.beginPath();
            context.moveTo(x, y);
            context.lineTo(nx, ny);
            context.strokeStyle = `rgba(43, 185, 237, ${Math.max(0, 0.13 - distance / 1800)})`;
            context.stroke();
          }
        }
      });

      frameId = requestAnimationFrame(render);
    };

    const start = () => {
      if (frameId || document.hidden || pageScrolling) return;
      isVisible = true;
      frameId = requestAnimationFrame(render);
    };

    const stop = () => {
      isVisible = false;
      if (frameId) {
        cancelAnimationFrame(frameId);
        frameId = 0;
      }
    };

    const handleVisibility = () => {
      if (document.hidden) {
        stop();
      } else if (canvas.dataset.mz3dCanvasInView === 'true' && !pageScrolling) {
        start();
      }
    };

    const scheduleScrollResume = () => {
      pageScrolling = true;
      stop();
      window.clearTimeout(scrollResumeTimer);
      scrollResumeTimer = window.setTimeout(() => {
        scrollResumeTimer = 0;
        pageScrolling = false;
        if (canvas.dataset.mz3dCanvasInView === 'true' && !document.hidden) start();
      }, 170);
    };

    const handlePageScroll = () => {
      if (canvas.dataset.mz3dCanvasInView !== 'true') return;
      scheduleScrollResume();
    };

    resize();
    window.addEventListener('resize', resize, { passive: true });
    window.addEventListener('scroll', handlePageScroll, { passive: true });
    document.addEventListener('visibilitychange', handleVisibility);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const inView = Boolean(entry && entry.isIntersecting);
        canvas.dataset.mz3dCanvasInView = inView ? 'true' : 'false';
        if (inView) {
          scheduleScrollResume();
        } else {
          window.clearTimeout(scrollResumeTimer);
          scrollResumeTimer = 0;
          pageScrolling = false;
          stop();
        }
      }, { rootMargin: '180px 0px', threshold: 0.01 });

      observer.observe(canvas);

      document.addEventListener('shopify:section:unload', () => {
        observer.disconnect();
      }, { once: true });
    } else {
      canvas.dataset.mz3dCanvasInView = 'true';
      start();
    }

    document.addEventListener('shopify:section:unload', () => {
      stop();
      window.clearTimeout(scrollResumeTimer);
      window.removeEventListener('resize', resize);
      window.removeEventListener('scroll', handlePageScroll);
      document.removeEventListener('visibilitychange', handleVisibility);
    }, { once: true });
  }

  function init(root) {
    document.body.classList.add('moztech-spatial-ready');
    initTiltCards(root || document);
    initHeroCanvas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target || document);
  });
})();
